/* eslint-disable react/prop-types */
/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-conditional */
/* eslint-disable no-unused-vars */
/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
/* eslint-disable max-len */
// Import Swiper React components
import { DeviceType } from '@scandipwa/scandipwa/src/type/Device';
import PropTypes from 'prop-types';
import React from 'react';
import SwiperCore, { Autoplay, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import BlogDesktop from './BlogDesktop';
// import BlogCard from "./BlogCard";
import BlogMobileCard from './BlogMobileCard';

import './BlogSlider.scss';
import 'swiper/swiper-bundle.css';

/** @namespace Mspwa/Component/Blog/BlogSlider/BlogSlider */
export const BlogSlider = ({ device, blogs }) => {
    SwiperCore.use([Navigation, Autoplay]);
    return (
        <div className="HealthBlog">
            <div className="HealthBlog-Top">
                <h1 className="HealthBlog-Top-LeftName">Health Blog</h1>
                <a
                  className="HealthBlog-Top-Viewall"
                  href="https://blog.medisouq.com"
                >
                    View all
                </a>

                { device.isMobile ? (
                    <div className="HealthBlog-Top-RightContainer">
                        <div className="HealthBlog-Top-RightContainer-Arrow">
                            <svg
                              className="blogPrev HealthBlog-Top-RightContainer-Arrow-ArrowLeft"
                              xmlns="http://www.w3.org/2000/svg"
                              width="31"
                              height="20"
                              viewBox="0 0 31 20"
                            >
                                <path
                                  id="Left_arrow"
                                  data-name="Left arrow"
                                  className="cls-1"
                                  d="M1456,2584h28a1,1,0,0,1,0,2h-28A1,1,0,0,1,1456,2584Zm7.32-8.71-9.03,9.03a0.983,0.983,0,1,0,1.39,1.39l9.03-9.03A0.983,0.983,0,1,0,1463.32,2575.29Zm-7.64,9,9.03,9.03a0.983,0.983,0,1,1-1.39,1.39l-9.03-9.03A0.983,0.983,0,1,1,1455.68,2584.29Z"
                                  transform="translate(-1454 -2575)"
                                />
                            </svg>
                            <svg
                              className="blogNext HealthBlog-Top-RightContainer-Arrow-ArrowRight"
                              xmlns="http://www.w3.org/2000/svg"
                              width="31"
                              height="20"
                              viewBox="0 0 31 20"
                            >
                                <path
                                  id="Right_arrow"
                                  data-name="Right arrow"
                                  className="cls-1"
                                  d="M1505,2584h28a1,1,0,0,1,0,2h-28A1,1,0,0,1,1505,2584Zm20.68-8.71,9.03,9.03a0.983,0.983,0,1,1-1.39,1.39l-9.03-9.03A0.983,0.983,0,1,1,1525.68,2575.29Zm7.64,9-9.03,9.03a0.983,0.983,0,1,0,1.39,1.39l9.03-9.03A0.983,0.983,0,1,0,1533.32,2584.29Z"
                                  transform="translate(-1504 -2575)"
                                />
                            </svg>
                        </div>
                    </div>
                ) : null }
            </div>

            { device.isMobile ? (
                <Swiper
                  style={ {} }
                  navigation={ {
                      prevEl: '.blogPrev',
                      nextEl: '.blogNext'
                  } }
                  spaceBetween={ 50 }
                  autoplay={ {
                      delay: 5000
                  } }
                  breakpoints={ {
                      1000: {
                          slidesPerView: 4
                      },
                      811: {
                          slidesPerView: 2
                      },
                      10: {
                          slidesPerView: 1
                      }
                  } }
                >
                    { blogs.map((blog) => (
                        <SwiperSlide>
                            <BlogMobileCard { ...blog } />
                        </SwiperSlide>
                    )) }
                </Swiper>
            ) : (
                <BlogDesktop blogs={ blogs } />
            ) }
        </div>
    );
};

export default BlogSlider;
